import { Time } from "@angular/common";

export class ContactModel {
  ContactId: string;
  ObjectId: string;
  ObjectType: string;
  FirstName: string;
  LastName: string;
  Gender: string;
  GenderDisplay: string;
  DateOfBirth: Date;
  Phone: string;
  WorkPhone: string;
  OtherPhone: string;
  Email: string;
  WorkEmail: string;
  OtherEmail: string;
  IdentityID: string;
  AvatarUrl: string;
  Address: string;
  CountryId: string;
  ProvinceId: string;
  DistrictId: string;
  WardId: string;
  MaritalStatusId: string;
  PostCode: string;
  WebsiteUrl: string;
  SocialUrl: string;
  CreatedById: string;
  CreatedDate: Date;
  UpdatedById: string;
  UpdatedDate: Date;
  Active: Boolean;
  Note: string;
  Role: string;
  TaxCode: string;
  Job: string;
  Agency: string;
  Birthplace: string;
  IdentityIDDateOfIssue: Date;
  IdentityIDPlaceOfIssue: string;
  IdentityIDDateOfParticipation: Date;
  WorkPermitNumber: string;
  VisaNumber: string;
  VisaDateOfIssue: Date;
  VisaExpirationDate: Date;
  SocialInsuranceNumber: string;
  SocialInsuranceDateOfIssue: Date;
  SocialInsuranceDateOfParticipation: Date;
  HealthInsuranceNumber: string;
  HealthInsuranceDateOfIssue: Date;
  HealthInsuranceDateOfParticipation: Date;
  WorkHourOfStart: Time;
  WorkHourOfEnd: Time;
  TypePaid: string;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/contact.model.ts